module.exports = __webpack_public_path__ + "static/assets/f01c9bdf2d08a15d64777cd093185778.png";